import React, { useContext, useEffect } from 'react';
import { classIf, getConfiguration, getMatchIdOrStageId } from '../../data/utils';
import BetGeniusWidget from '../../data/widgets/BetGeniusWidget';
import FlashbetWidget from '../../data/widgets/FlashbetWidget';
import StatsCoreWidget from '../../data/widgets/StatsCoreWidget';
import { bgWidgetEnabled, brWidgetS5Enabled, getBetgeniustWidgetUrl, getFlashbetWidgetUrl, statsCoreWidgetEnabled, STATSCORE_WIDGET_LIVESCORE, WidgetContext } from '../../data/widgets/WidgetContext';
import BetradarWidget from '../../data/widgets/BetradarWidget';
import WidgetWrapper from '../WidgetWrapper';

export default function LiveTracker(props) {
    const widgetContext = useContext(WidgetContext);
    const widgetTemplate = getConfiguration()['wdgt'];
    const match = props.data;

    useEffect(() => {
        window.addEventListener('xs-close-live-tracker', closeTracker);

        return () => {
            window.removeEventListener('xs-close-live-tracker', closeTracker);
            // streamingContext.toggleStreamingId(null,null,null);
        };
    }, []);

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('xs-close-streaming'));
        widgetContext.setWidget({
            widgetSportId: match.sportRef,
            widgetStartCollapsed: true,
            widgetS5Layout: widgetTemplate,
            widgetGeniusId: match.geniusId,
            widgetLsportId: match.lsportWidgetId,
            widgetProviderType: match.widgetType,
            widgetMatchId: getMatchIdOrStageId(match),
            widgetContainerId: '#br_widget'
        });
    }, [match.id]);

    if (widgetContext.widgetMatchId == null) {
        return null;
    }

    function closeTracker() {
        widgetContext.update({
            widgetContainerId: null,
            widgetMatchId: null
        });
    }

    const flashbetWidgetUrl = getFlashbetWidgetUrl(match.widgetType);
    const isBetgeniusWidget = bgWidgetEnabled(match.sportRef, match.widgetType, match.geniusId);
    const isStatsCoreWidget = statsCoreWidgetEnabled(STATSCORE_WIDGET_LIVESCORE, widgetContext.widgetProviderType, match.lsportWidgetId);

    const content = (
        <>
            {function () {
                if (flashbetWidgetUrl) {
                    return (
                        <div id="br_widget" className="overlay-container-flashbet-widget">
                            {widgetContext.widgetContainerId === '#br_widget' && 
                                <FlashbetWidget url={flashbetWidgetUrl}/>
                            }
                        </div>
                    );
                } else if (isBetgeniusWidget) {
                    return (
                        <>
                            {widgetContext.widgetContainerId === '#br_widget' &&
                                <BetGeniusWidget url={getBetgeniustWidgetUrl(match.sportRef, match.categoryRef, match.tournamentRef)} />
                            }
                        </>
                    );
                } else if (isStatsCoreWidget) {
                    return (
                        <>
                            {widgetContext.widgetContainerId === '#br_widget' && 
                                <StatsCoreWidget />
                            }
                        </>
                    );
                } else {
                    const isBrWidgetS5 = brWidgetS5Enabled(match.sportRef, match.widgetType);
                    return (
                        <>
                            {widgetContext.widgetContainerId === '#br_widget' && 
                                <BetradarWidget id="br_widget"
                                                className={"betradar-widget sr-widget sr-widget-level-0 sr-widgets-lmts sr-size-small sr480" + classIf(isBrWidgetS5, 'brWidgetS5')}
                                                data-sr-lang="it"
                                                data-sr-handle="16" 
                                                matchId={match.id}
                                />
                            }
                        </>
                    );
                }
            }()}
        </>
    );

    if (props.wrapper) {
        return (
            <WidgetWrapper data={match} close={closeTracker}>
                {content}
            </WidgetWrapper>
        );
    }

    return content;
}
